import { FieldType } from '@pmp/api';

export const EXCLUSIVE_SETS_ENTITY_LIST_NAMES: FieldType[] = [FieldType.FIRMS];
